"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberColumnsSet = exports.strandFlags = exports.numberColumns = void 0;
exports.numberColumns = [
    'start1',
    'end1',
    'len1',
    'start2',
    'end2',
    'len2',
    'alignLen',
    'identity',
    'evalue',
    'bitScore',
    'otherNumber',
];
exports.strandFlags = {
    minimapStrand: ['+', '-'],
    nucmerStrand: ['Plus', 'Minus'],
};
exports.numberColumnsSet = new Set(exports.numberColumns);
